import AnnounceText from './AnnounceText';
import Section from './Section';
import IMG_GUIDE_1 from '@/assets/korUploadFile/img_guide_1.png';
import IMG_GUIDE_2 from '@/assets/korUploadFile/img_guide_2.png';
import IMG_GUIDE_3_1 from '@/assets/korUploadFile/img_guide_3_1.png';
import IMG_GUIDE_4_1 from '@/assets/korUploadFile/img_guide_4_1.png';
import IMG_GUIDE_4_2 from '@/assets/korUploadFile/img_guide_4_2.png';
import IMG_GUIDE_EX from '@/assets/korUploadFile/img_guide_ex.png';
import styled from 'styled-components';
import ExplainDetail from './ExplainDetail';
import Accordian from './Accordian';
import { useState } from 'react';
import { Icon } from '@successmode-ktp/kui';

type Props = {
  onClick: () => void;
};

const KakaoGuide = ({ onClick }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <AnnounceText onClick={onClick} />
      <Section
        step='step 1'
        title='카카오톡 → 더보기 → 전자증명서 클릭'
        imgSrc={IMG_GUIDE_1}
      />
      <Section
        step='step 2'
        title='출입국 사실증명 선택'
        imgSrc={IMG_GUIDE_2}
      />
      <div>
        <Accordian onClick={() => setIsOpen(!isOpen)} />
        {isOpen && (
          <div>
            <ImgException src={IMG_GUIDE_EX} alt='' />
            <ExceptionText>
              <Strong>'정부 24 비회원으로 신청하기'</Strong>로 선택해
              진행해주세요
            </ExceptionText>
          </div>
        )}
      </div>
      <div>
        <Section
          step='step 3'
          title='본인인증 및 발급신청'
          imgSrc={IMG_GUIDE_3_1}
        />
        <ExplainDetail />
      </div>
      <div>
        <Section
          step='step 4'
          title='저장하기 → 비밀번호 설정 없이 저장하기'
          imgSrc={IMG_GUIDE_4_1}
        />
        <ChevronWrapper>
          <Icon.ChevronDown size={30} />
        </ChevronWrapper>
        <Section step='' title='' imgSrc={IMG_GUIDE_4_2} />
        <ChevronWrapper>
          <Icon.ChevronDown size={30} />
        </ChevronWrapper>
        <NoticeText>파일에 저장</NoticeText>
      </div>
      <div>
        <Section
          step='step 5'
          title='업로드 하러가기를 눌러 저장된 파일 업로드'
        />
        <Text>(PDF, 캡처본 모두 업로드 가능합니다.)</Text>
      </div>
    </Wrapper>
  );
};
export default KakaoGuide;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 16px 0 40px;
`;

const Text = styled.p`
  color: var(--KTP-Warning-100, #ed0828);
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ChevronWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

const NoticeText = styled.strong`
  display: block;
  text-align: center;
  color: #000;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const ImgException = styled.img`
  display: block;
  margin: 24px 0;
  width: 100%;
`;

const ExceptionText = styled.p`
  color: var(--KTP-Grayscale-Gray_03, #333);
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
  border-radius: 8px;
  background: var(--KTP-Grayscale-Gray_12, #f4f4f4);
  padding: 16px;
`;

const Strong = styled.strong`
  font-weight: 800;
`;
